import React from 'react';
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell
} from '@mui/material';
import {
  formatURLTitle
} from '../../../helpers/http.js';

const PurchaseItems = ({ items }) => {
  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell>Title</TableCell>
          <TableCell>Author</TableCell>
          <TableCell>Price</TableCell>
          <TableCell>Discount</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {
          items.map(item => {
            const product = item.product || item.subscriptionPlan.subscription;
            return (
              <TableRow key={item.id}>
                <TableCell>
                  {
                    item.subscriptionPlan
                      ? (
                        <a href={`/admin/subscriptions/${product.id}/${formatURLTitle(product.title)}`}>
                          {product.title} ({item.subscriptionPlan.type})
                        </a>
                        )
                      : (
                        <a href={`/admin/products/${product.type}/${product.id}/${formatURLTitle(product.title)}`}>
                          {product.title}
                        </a>
                        )
                  }
                </TableCell>
                <TableCell>
                  {
                    product.author
                      ? (
                        <>{product.author.fullName}</>
                        )
                      : (
                        <>N/A</>
                        )
                  }
                </TableCell>
                <TableCell>{item.price}</TableCell>
                <TableCell>{item.discount}%</TableCell>
              </TableRow>
            );
          })
        }
      </TableBody>
    </Table>
  );
};

export default PurchaseItems;
